module.exports = __webpack_public_path__ + "img/FlagForCorrectAnsBelowAvgTime.a2a11d11.svg";